import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { LiveClassTeacherReminderNotification } from '@openeducation/oe-it-shared-types';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';

import { useMessages } from './use-messages';
import { ActiveClasses } from '../services/active-classes.service';

export function useClassEmpty(
  classEmpty?: LiveClassTeacherReminderNotification
) {
  const { remove } = useMessages();
  const { environment } = useEnvironmentContext();

  const { mutateAsync: updateClassStatus } = useMutation((status: string) => {
    return ActiveClasses.updateClassStatus(
      environment,
      classEmpty?.classroomId,
      status
    );
  });

  const [isClassEmptyVisible, setIsClassEmptyVisible] = useState(!!classEmpty);
  useEffect(() => {
    setIsClassEmptyVisible(!!classEmpty);
  }, [classEmpty]);

  const onConfirmClassEmpty = () => {
    classEmpty && remove(classEmpty.id);
    setIsClassEmptyVisible(false);
  };
  const onCancelClassEmpty = () => {
    updateClassStatus('CLASS_CLOSED');
    classEmpty && remove(classEmpty.id);
    setIsClassEmptyVisible(false);
  };
  return {
    isClassEmptyVisible,
    onConfirmClassEmpty,
    onCancelClassEmpty,
  };
}
